'use client';

import type { ArticlePreview } from '@dealerportal/common';
import { toKebab } from '@dealerportal/utilities';
import { useEffect, useState } from 'react';

export function useArticles(slug: string | 'blog', tags: string | string[]) {
  const [articles, setArticles] = useState<ArticlePreview[]>([]);

  tags = Array.isArray(tags) ? tags : [tags];
  tags = tags.map((tag) => toKebab(tag)).join(',');

  useEffect(() => {
    fetch(`/api/articles?slug=${slug}${tags.length ? `&tags=${tags}` : ''}`)
      .then((res) => res.json())
      .then(({ articles }) => setArticles(articles ?? []));
  }, [slug, tags]);

  return articles;
}
